var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("header", { staticClass: "checkout--header" }, [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c("div", { staticClass: "logo" }, [
          _c("a", { attrs: { href: _vm.homeURL } }, [
            _c("img", { attrs: { src: _vm.logos.mobileAlternateUri } }),
          ]),
        ]),
        _vm._v(" "),
        _c("steps"),
        _vm._v(" "),
        !_vm.steps.confirmation &&
        ((_vm.shoppingCart && _vm.shoppingCart.expiresAt) ||
          (_vm.order && _vm.order.expiresAt))
          ? _c("countdown")
          : _vm._e(),
        _vm._v(" "),
        !_vm.steps.confirmation
          ? _c("button", {
              staticClass: "close",
              on: {
                click: function ($event) {
                  return _vm.abandonCart()
                },
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.steps.confirmation
          ? _c("a", { staticClass: "close", attrs: { href: "/" } })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }